/**
 * Created by tiedong on 2017/7/19.
 */
import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'
const reducers = {}
const initialState = {
    selectedReport:{},
    isShowReturnedModal: false,
    returnType: '',
    isShowRemarkModal: false,
    isDeflossPreviewModal: false,
    nextTime:undefined,
    followDetails:{},
}


reducers[types.SELECTED_REPORT] = (state, action) => {
    return Object.assign({}, state, {selectedReport: action.payload.data})
}


reducers[types.SET_RETURNED_MODAL] = (state,action) =>{
    if(!action.error){
        return Object.assign({}, state, {...action.payload})
    }
}

reducers[types.SET_DEFLOSS_PREVIEW_MODAL] = (state,action) =>{
    if(!action.error){
        return Object.assign({}, state, {...action.payload})
    }
}
reducers[types.AGENT_ACCEPT_REPORT_FINISH] = (state, action) => {
    return Object.assign({}, state,{selectedReport: action.payload})
}


export default handleActions(reducers, initialState)